import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20live%20streaming%20broadcast%20studio%20with%20dynamic%20geometric%20shapes%20and%20flowing%20light%20trails%20in%20warm%20coral%20and%20gold%20colors%2C%20artistic%20digital%20art%20style%2C%20soft%20glowing%20particles%20floating%2C%20minimalist%20composition%20with%20smooth%20gradients%2C%20ethereal%20atmosphere%20with%20dark%20background%20and%20vibrant%20warm%20accents%2C%20futuristic%20yet%20inviting&width=1800&height=900&seq=hero-bg-main-01&orientation=landscape"
        alt="直播互动体验平台 - 沉浸式直播娱乐体验"
        title="直播互动体验平台 - 实时连线娱乐新体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white font-serif leading-tight mb-6">
          探索全新<strong className="text-primary-300">直播互动</strong>体验
        </h1>
        <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-xl mx-auto">
          与真实主播实时连线，畅享高清视频直播娱乐内容。平台安全可靠，注册即享专属福利，随时随地开启沉浸式直播互动新体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/caibiao"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-white font-semibold border border-white/25 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}